// extracted by mini-css-extract-plugin
export default {"sectionHeader":"SectionHeader_sectionHeader__ijMPf","sectionLabel":"SectionHeader_sectionLabel__0x6-o"};